import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'
import { PARTICIPANT_SIDE_ROLES } from '@/lib/participant-side-roles'
import { MyDeclarationsPage } from '@/features/my-declarations/page'

/**
 * A worker's own conflict-of-interest declarations (compliance phase 4c / C6).
 *
 * No staff-role list — declaring a conflict is something every STAFF member
 * needs to be able to do, and the API's create route has no read guard for the
 * same reason. But a participant or their primary contact is a member too, and
 * the API refuses them (`requireCoiDeclarer`, review I2), so the page does not
 * offer them a form that can only fail. The list read is a self-read, so it can
 * never show anybody else's.
 */
export const Route = createFileRoute('/_authenticated/_organization/my-declarations/')({
  beforeLoad: async () => {
    const session = await requireAuth()
    const role = session?.member?.role
    if (role && PARTICIPANT_SIDE_ROLES.has(role)) {
      throw redirect({ to: '/403', replace: true })
    }
    return session
  },
  component: MyDeclarationsPage,
})
